export enum MODES {
    DATETIME = 'datetime',
    DATE = 'date',
}

export enum VIEWS {
    WITH_POPUP = 'with-popup',
    WITHOUT_POPUP = 'without-popup',
}
